<template>
  <div class="carousel">
    <el-carousel :autoplay="true">
      <el-carousel-item v-for="item of carouselList" :key="item.url">
        <el-image :src="item.url" fit="cover" @click="clickCarousel(item)"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="categoryContainer">
      <div v-for="category of $store.state.basicInfo.categoryList_quotation" :key="category.id" class="category">
        <div class="category_name" @click="goHomeQuotation(category.id)">
          {{ l(category.name) }}
        </div>
        <div v-if="$store.state.lang=='zh-CN'" class="category_children">
          <div v-for="child of category.child" :key="child.id">
            <span @click="goHomeQuotation(category.id, child.name)">
              {{ l(child.name) }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="mainInfo">
      <div v-if="$store.state.session.token" key="has_token" class="userContainer" style="cursor: pointer"
        @click="$router.push({ path: '/backend' })">
        <div class="avatarContainer">
          <el-image class="avatar" fit="cover" :src="$store.state.session.user.avatar">
          </el-image>
        </div>

        <div class="userName one_lines">
          {{ $store.state.session.user.display_name }}
        </div>
        <div v-if="
          !$store.state.session.tenant
        " class="noCompany">
          {{ l("完成企业认证,解锁更多权益") }}
        </div>
        <div v-else class="companyName">
          <span class="one_lines">{{ $store.state.session.tenant.name }}</span>
        </div>
      </div>
      <div v-else key="no_token" class="userContainer">
        <el-image class="avatar" fit="cover" :src="GetResourceUrl('default-avatar.png')">
        </el-image>
        <div class="one_lines">{{ l("Hi，你好！") }}</div>

        <div class="buttonList">
          <div @click="$store.commit('logout')">{{ l("登录") }}</div>
          <div class="button_2" @click="$router.push({ path: '/register' })">
            {{ l("注册") }}
          </div>
        </div>
      </div>
      <div class="platformContainer">
        <div class="iconList">
          <div class="iconItem" @click="$router.push({ path: '/backend/seller_quotation' })">
            <el-image :src="GetResourceUrl('index/product.svg')"></el-image>
            <div class="font">{{ l("现货管理") }}</div>
          </div>
          <div class="iconItem" @click="$router.push({ path: '/backend/buyer_purchase_forging' })">
            <el-image :src="GetResourceUrl('index/forging.svg')"></el-image>
            <div class="font">{{ l("锻件管理") }}</div>
          </div>

          <div class="iconItem" @click="$router.push({ path: '/backend/buyer_purchase_material' })">
            <el-image :src="GetResourceUrl('index/purchase.svg')"></el-image>
            <div class="font">{{ l("求购管理") }}</div>
          </div>
          <!-- <div class="iconItem" @click="$router.push({ path: '/backend/buyer_purchase_piece' })">
            <el-image :src="GetResourceUrl('index/piece.svg')"></el-image>
            <div class="font">{{ l("零切管理") }}</div>
          </div> -->
          <div class="iconItem" @click="$router.push({ path: '/backend/buyer_purchase_machining' })">
            <el-image :src="GetResourceUrl('index/machining.svg')"></el-image>
            <div class="font">{{ l("机加工") }}</div>
          </div>
        </div>
        <!-- <div class="goBackend">
          <router-link to="/backend/dashboard"
            >进入个人中心<i class="el-icon-arrow-right"></i
          ></router-link>
        </div> -->
      </div>
      <div class="dynamicContainer">
        <div class="title_line">
          <span class="title">{{ l("中锻材动态") }}</span>
          <span class="count">
            {{ l("当前在线")
            }}<span class="color-warning" style="margin: 0 2px">{{
              online_number
            }}</span>{{ l("人") }}
          </span>
        </div>
        <Carousel class="dynamicList" :initList="dynamicList" :childHeight="30" :parentHeight="100" :speed="0.3">
          <template #default="scope">
            <div class="dynamicItem" :style="{
              height: scope.childHeight + 'px',
              'line-height': scope.childHeight + 'px',
            }">
              <div class="point"></div>
              <div class="content">
                {{ scope.item }}
              </div>
            </div>
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/gadget/Carousel.vue";

export default {
  name: "HomeIndexCarousel",
  components: { Carousel },
  data() {
    return {
      carouselList: [],
      dynamicList: [],
      online_number: "",
      timer: null,
    };
  },

  created() {
    this.getCarousel();
    this.getTimeDynamic();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    getCarousel() {
      this.axios
        .get("/api/banner/", {
          params: {
            position: "carousel",
            show_pc: true,
            is_show: true,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
    goHomeQuotation(category_id, child_category) {
      this.$router.push({
        path: "/home/quotation",
        query: { category_id, child_category },
      });
    },
    getTimeDynamic() {
      clearTimeout(this.timer);
      this.axios
        .get("/api/website_dynamic/time_dynamic/", {
          showLoading: false,
        })
        .then((data) => {
          this.online_number = data.online_number;
          if (!this.dynamicList.length) {
            this.dynamicList = data.dynamic;
          }
        })
        .finally(() => {
          this.timer = setTimeout(() => {
            this.getTimeDynamic();
          }, 20000); //20秒一次更新
        });
    },
  },
};
</script>


<style scoped lang="scss">
.carousel {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  height: 500px;
  position: relative;

  .el-carousel {
    width: 100%;
    height: 100%;

    /deep/.el-carousel__container {
      height: 100%;

      .el-carousel__item {
        height: 100%;
      }

      .el-carousel__item .el-image {
        height: 100%;
        width: 100%;
      }
    }
  }

  .categoryContainer {
    height: 100%;
    width: 225px;
    // background: rgba(50, 50, 50, 0.7);
    background: rgba($themeColor, 0.6);
    position: absolute;
    top: 0;
    left: calc(50% - #{$HomeContainerWidth/2});
    z-index: 5;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    letter-spacing: 1px;
    font-size: 12px;

    box-sizing: border-box;
    padding: 10px 0;

    .category {
      padding: 10px 0 12px 15px;
      border-bottom: 1px solid #56637e;
      flex-grow: 1;

      &:last-child {
        border: none;
      }

      .category_name {
        display: inline-block;
        font-weight: bold;
        line-height: 24px;
        font-size: 13px;
        cursor: pointer;

        &:hover {
          color: $warningColor;
        }
      }

      .category_children {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        div {
          width: 25%;
          margin-top: 5px;

          span {
            cursor: pointer;

            &:hover {
              color: $warningColor;
            }
          }
        }
      }
    }
  }

  .mainInfo {
    height: 500px;
    width: 250px;
    background: #fff;
    position: absolute;
    top: 0;
    right: calc(50% - #{$HomeContainerWidth/2});
    z-index: 5;

    .userContainer {
      text-align: center;
      height: 178px;
      box-sizing: border-box;
      padding-top: 20px;

      .avatarContainer {
        width: 60px;
        height: 60px;
        position: relative;
        margin: 0 auto 15px;
        display: block;

        .avatar {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .buttonList {
        margin-top: 20px;
        width: 100%;
        padding: 0 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        div {
          color: #fff;
          border: 1px solid $warningColor;
          background: $warningColor;
          width: 82px;
          text-align: center;
          padding-top: 4px;
          padding-bottom: 4px;
          font-size: 14px;
          cursor: pointer;

          &.button_2 {
            color: $warningColor;
            background: #fff;
          }
        }
      }

      .userName {
        padding-top: 5px;
      }

      .companyName {
        box-sizing: border-box;
        margin: 15px auto 0;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-image {
          width: 22px;
          height: 24px;
          margin-right: 4px;
        }
      }

      .noCompany {
        width: 80%;
        box-sizing: border-box;
        margin: 15px auto 0;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        color: $warningColor;
        background: $warningPlainColor;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 6px;
        border: 1px solid transparent;
        animation: mymove 0.6s infinite linear; //ease
        border-color: $warningColor;
      }

      @keyframes mymove {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.05);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .platformContainer {
      border-top: 1px solid $borderPlainColor;
      border-bottom: 1px solid $borderPlainColor;
      font-size: 12px;
      height: 172px;
      box-sizing: border-box;

      .iconList {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 20px;

        .iconItem {
          width: 50%;
          height: 86px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #333;

          .el-image {
            width: 32px;
            height: 32px;
          }

          .font {
            margin-top: 12px;
          }

          &:hover {
            color: $warningColor;
          }
        }
      }

      .goBackend {
        text-align: center;
        margin-top: 24px;

        a {
          color: $warningColor;
        }
      }
    }

    .dynamicContainer {
      height: 150px;
      padding: 0 20px;

      .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: 14px;
          font-weight: bold;
          height: 40px;
          line-height: 40px;
        }

        .count {
          color: #666;
          font-size: 12px;
        }
      }

      .dynamicList {
        // height: 90px;
        overflow: hidden;
        color: #616161;
        box-sizing: border-box;
        margin-bottom: 10px;
        font-size: 12px;

        .dynamicItem {
          // height: 30px;
          // line-height: 30px;
          display: flex;
          align-items: center;

          .point {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #616161;
            margin-right: 6px;
          }

          .content {
            width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
